(function ($) {

    $(document).ready(function () {

        //HOME flex slider

        $('.flex-slider .slider').flickity({
            autoPlay: true,
            autoPlay: 5000,
            draggable: true,
            cellSelector: '.slide',
            prevNextButtons: true,
            cellAlign: 'center',
            wrapAround: true,
            contain: true,
            pageDots: false,
            adaptiveHeight: true,
			selectedAttraction: 0.008,
			friction: 0.2
        });

        $('.flex-news .carousel').flickity({
            autoPlay: false,
            draggable: true,
            cellSelector: '.single',
            prevNextButtons: true,
            cellAlign: 'left',
            wrapAround: false,
            contain: true,
            pageDots: false,
            adaptiveHeight: false,
        });



    });

})
    (jQuery);